import Vue from "vue";
import { Component, } from "vue-property-decorator";

import { ClientNotifier } from "../../scripts/ah.mb.client-notifications";
import { AccountServices } from "../../scripts/ah.modelbuilder.account-services";
import { bootbox } from "../../infrastructure/bootbox-shim";
import { FetchWrapper } from "../../infrastructure/fetch-wrapper";

import { MessageBox } from "uiv";


//import "admin-lte/dist/css/AdminLTE.css";


//var $ = require('jquery');
//global.jQuery = require("jquery");
//window.$ = $;

//import "bootstrap";

@Component
export default class AccountsIndex extends Vue {

//@Scripts.Render(
//    "~/bundles/datatables",
//    "~/bundles/account-services"
//    );
    showRegisterDialog: boolean = false;

    showEditUserDialog: boolean = false;
    userNameToEdit: string = "";


    mounted() {

        this.populateTable();

    }


    // Refresh
    refreshTable() {
        this.table.ajax.reload();
    };


// Create services observable
    private accountServices = new AccountServices();

    private table = null;

// Script list drawer
    populateTable() {
        const url = "accounts/indexasdt"; //  "@Url.Action("IndexAsDt", "Account")";

        // Because mvc datatables expects variables in the old format we have to set
        // it to specifically use the old variables, because we are using ajax option below
        //$.fn.dataTable.ext.legacy.ajax = true;

        const tableSettings: DataTables.Settings = {
            processing: false,
            serverSide: true,

            ajax: {
                type: "POST",
                url: url,
                error: () => {

                    MessageBox.alert({
                            title: "Account List",
                            content: "SuperUser or Adminstrator level access is required to to access the list of users"
                        },
                        () => {});
                }
            },


//            sServerMethod: "POST",
            autoWidth: true,
            stateSave: true,
            order: [0, "asc"],
            searching: true,
            paging: true,
            pageLength: 25,

            // Row callback, for enabling/disabling buttons
            //rowCallback: this.tableRowCallback,

            // Draw callback, for attaching button handlers
            drawCallback: this.tableDrawCallback,

            //// For 24-cell grid system
            //"dom": "<'row'<'col-sm-12'l><'col-sm-12'f>>" +
            //    "<'row'<'col-sm-24'tr>>" +
            //    "<'row'<'col-sm-10'i><'col-sm-4'p>>",

            columns: [
                {
                    title: "Name",
                    data: "username",
                    //width: "5%"

                },
                //{
                //    "title": "First",
                //    "targets": [1],
                //    "data": 1,
                //    "width": "7%"

                //},
                //{
                //    "title": "Last",
                //    "targets": [2],
                //    "data": 2,
                //    "width": "7%"

                //},
                {
                    title: "Groups",
                    data: "userGroups",
                    //width: "10%"

                },
                {
                    title: "Email",
                    data: "email",
                    //width: "20%"

                },
                {
                    title: "Roles",
                    data: "roles",
                    //width: "17%"
                },
                {
                    title: "Last Login",
                    data: "lastLoginDate",
                    //width: "15%",
                    render(data) {
                        const dateStr = data;
                        const date = new Date(dateStr);
                        return date.toLocaleString();
                    }
                },
                {
                    title: "Confirmed",
                    data: "isConfirmed",
                    ////width: "15%",
                    render(data) {
                        return `<div class="checkbox"><input type="checkbox" ${data ? "checked" : ""} disabled/></div>`;

                    }
                },

                {
                    title: "Approved",
                    data: "isApproved",
                    ////width: "15%",
                    render(data) {
                        return `<div class="checkbox"><input type="checkbox" ${data ? "checked" : ""} disabled/></div>`;

                    }
                },
                {
                    searchable: false,
                    orderable: false,
                    title: "Options",
                    //width: "33%",
                    render: (data, type, oObj) => {
                        const itemId = oObj.username;
                        let openDiv =`<div class=\" btn-toolbar\">`;
                        let editBtn = `<a class="btn btn-sm btn-default btn-sm edit-user-button" data-objectId=${itemId
                            }>Edit</a>`;
                        let changePwBtn = `<a class="btn btn-sm btn-default" data-objectId=${itemId} id="changeUserPasswordButton${itemId
                            }\">Reset Password</a>`;
                        let deleteBtn = `<a class="btn btn-sm btn-warning" data-objectId=${itemId} id="deleteUserButton${itemId}\">Delete</a>`;
                        let closeDiv = `</div>`;

                        let manualAuthorizeBtn = `<a class="btn btn-sm btn-default manual-override-pw-btn" data-objectId=${itemId}\>Manually authorize</a>`;

                        return `${openDiv}${editBtn}${changePwBtn}${manualAuthorizeBtn}${deleteBtn}${closeDiv}`;

                    }
                }
            ]

        };


        this.table = $("#userTable")
            .DataTable(tableSettings);


    };



    doShowEditUserDialog(userName: string) {
        this.userNameToEdit = userName;
        this.showEditUserDialog = true;
    }

// Table draw callback
    private tableDrawCallback() {
        $("[id^=deleteUserButton]")
            .click((e) => {

                var objectId = $(e.target).attr("data-objectId");

                MessageBox.confirm({ title: "Delete user", content: `Delete user "${objectId.toString()}"?` })
                    .then(() => {
                        this.accountServices.deleteUser(objectId)
                            .then(data => {
                                
                                if (data.success)
                                    this.refreshTable();
                            });
                    });
            });

        $(".edit-user-button").click(e => {

            var objectId = $(e.target).attr("data-objectId");
            this.doShowEditUserDialog(objectId);
            });


        // Change password button handler
        $("[id^=changeUserPasswordButton]")
            .click(e => {
                e.preventDefault();


                var objectId = $(e.target).attr("data-objectId");

                bootbox.confirm(`Send password reset email to ${objectId}?`,
                    ok => {
                        if (ok) {
                            const payload = { userName: objectId };

                            FetchWrapper.sendCommandAndHandle(`/accounts/sendpasswordreset`,
                                { method: "post", body: JSON.stringify(payload) });

                        }
                    });
            });

        $(".manual-override-pw-btn")
            .click(e => {

                e.preventDefault();
                var objectId = $(e.target).attr("data-objectId");


                bootbox.confirm(`Manually authorize user ${objectId}?  This will auto-generate a password.`,
                    ok => {
                        if (ok) {
//                            const payload = { userName: objectId };

                            FetchWrapper.sendCommandAndHandle(`/api/1.0/accounts/${objectId}/manuallyauthorize`,
                                { method: "post"}, false)
                                .then(response => bootbox.alert(response.response));

                        }
                    });

            })
    };

    onEditUserDialogClosed(result: string) {
        this.showEditUserDialog = false;

        if (result === "ok")
            this.refreshTable();
    }

    onRegisterUserDialogClosed(result: string) {
        this.showRegisterDialog = false;

        if (result === "ok")
            this.refreshTable();
    }
}






// WEBPACK FOOTER //
// ./ClientApp/components/accounts/accounts-index.ts